
import Vue, { PropType } from 'vue';
import Card from '@/components/cards/Card.vue';
import ProgressBar from '@/components/progress/ProgressBar.vue';
import { Lesson } from '@/models/kingslanding/studyPlanModel';
import { ClassroomModel, ListModel } from '@descomplica/dex-models';
import EventCardSkeleton from '@/components/skeletons/studyPlan/undergrad/EventCardSkeleton.vue';
import Analytics from '@/helpers/analytics';
import { EVENT_LABELS } from '@/helpers/analytics/labels';

export default Vue.extend({
  components: {
    Card,
    ProgressBar,
    EventCardSkeleton,
  },
  props: {
    activity: {
      required: true,
      type: Object as PropType<Lesson>,
    },
  },
  computed: {
    lesson(): ListModel {
      return this.$store.getters.listById(this.activity.pedagogicalActivityId);
    },
    lessonProgress(): number {
      return this.lesson?.progress || 0;
    },
    classroom(): ClassroomModel {
      return this.$store.getters.classroomById(this.activity.disciplineId);
    },
    name(): string {
      return this.lesson?.name || '';
    },
    isActivityLoaded(): boolean {
      return this.$store.getters.isActivityLoaded(this.activity.pedagogicalActivityId);
    },
    title(): string {
      return this.classroom?.name || '';
    },
  },
  methods: {
    goToClass(): void {
      this.$router.push({
        name: 'lesson',
        params: {
          classroomSlug: this.classroom.slug,
          listSlug: this.lesson.slug,
        },
      });

      this.trackingStudyPlanInteracted();
    },
    trackingStudyPlanInteracted(): void {
      Analytics.trackEvent(EVENT_LABELS.studyPlanInteracted, {
        interaction_type: 'Study Plan Content Clicked',
        content_type: 'Lesson',
      });
    },
  },
});
